import { useMemo } from "react";

type Props = Readonly<{
  currentPage: number;
  perPage: number;
  total: number;
}>;

export const PaginationResult = ({ currentPage, perPage, total }: Props) => {
  const currentInterval = useMemo(
    () => ({
      from: (currentPage - 1) * perPage + 1,
      to: Math.min(currentPage * perPage, total),
    }),
    [currentPage, perPage, total],
  );

  return (
    <p>
      Mostrando <strong>{currentInterval.from}</strong> de <strong>{currentInterval.to}</strong> de{" "}
      <strong>{total}</strong>
    </p>
  );
};
